import React from 'react';
import { Users, BookOpen, Star, MapPin } from 'lucide-react';
export function StatsBar() {
  const stats = [{
    icon: Users,
    value: '+300',
    label: 'PROFES CONFÍAN'
  }, {
    icon: BookOpen,
    value: '6+6',
    label: 'TOMOS + BONOS'
  }, {
    icon: Star,
    value: '4.9/5',
    label: 'CALIFICACIÓN ⭐'
  }, {
    icon: MapPin,
    value: '🇦🇷',
    label: 'TODO EL PAÍS'
  }];
  return <div className="bg-lime-500 border-y border-lime-400" data-id="element-353">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-354">
        <div className="grid grid-cols-2 md:grid-cols-4 divide-x divide-lime-600/30" data-id="element-355">
          {stats.map((stat, index) => <div key={index} className="py-3 md:py-6 px-2 md:px-4 flex flex-col items-center justify-center text-center" data-id="element-356">
              <span className="text-2xl md:text-4xl font-display font-bold text-dark-900 mb-0.5 md:mb-1" data-id="element-357">
                {stat.value}
              </span>
              <span className="text-[10px] md:text-sm font-bold text-dark-800 tracking-wider uppercase" data-id="element-358">
                {stat.label}
              </span>
            </div>)}
        </div>
      </div>
    </div>;
}